import { Component, EventEmitter, Input, OnChanges, Output, inject } from '@angular/core';
import { WelcomeSplashService } from '@core/components/welcome-splash/welcome-splash.service';
import { formatOrderDisplayNumber } from '@modules/bcm/@shared/utils/invoice-position-source.util';

@Component({
    selector: 'bcm-order-link',
    templateUrl: './order-link.component.html',
    standalone: false,
})
export class OrderLinkComponent implements OnChanges {
    @Input()
    orderId!: number;

    @Input()
    dataTest?: string;

    @Input()
    disableLink = false;

    @Input()
    openInNewTab = false;

    @Output()
    clicked = new EventEmitter<void>();

    viewData: string;

    private readonly _welcomeSplashService = inject(WelcomeSplashService);

    ngOnChanges(): void {
        this.viewData = this.orderId ? formatOrderDisplayNumber(this.orderId) : null;
    }

    prepareNewTab(event: MouseEvent): void {
        if (!this.openInNewTab || this.disableLink) {
            return;
        }

        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey) {
            return;
        }

        this._welcomeSplashService.prepareForInternalNewTab();
    }

    click(event: MouseEvent): void {
        this.clicked.emit();
        event.stopPropagation();
    }
}
